import React from 'react';
import { MessageCircle, Check } from 'lucide-react';
export function FinalCTA() {
  return <section className="py-24 bg-dark-100" data-id="element-14" data-mp="3ucx51ikqtt0s">
      <div className="max-w-6xl mx-auto px-4 sm:px-6 lg:px-8" data-id="element-15" data-mp="3udyks0cpf3ou">
        <div className="text-center mb-16" data-id="element-16" data-mp="c70y9baodhp3">
          <h2 className="text-3xl md:text-5xl font-bold text-white mb-6" data-id="element-17" data-mp="c83ln98sh209">
            Tu Negocio Hace Un Trabajo Premium.{' '}
            <br className="hidden md:block" data-id="element-18" data-mp="m4yilnpeyucf" />
            <span className="text-gold" data-id="element-19" data-mp="m3nh5ujfxyoh">
              Es Hora De Que Tu Website Lo Demuestre.
            </span>
          </h2>
          <p className="text-xl text-gray-400 max-w-3xl mx-auto" data-id="element-20" data-mp="h3rbzrz0c17c">
            Empieza hoy con solo $125. Tu website profesional listo en menos de
            72 horas. Sin mensualidades obligatorias. Sin contratos. Sin
            complicaciones.
          </p>
        </div>

        <div className="grid lg:grid-cols-2 gap-12 items-center" data-id="element-21" data-mp="14vzicdycytx1">
          {/* WhatsApp Card */}
          <div className="border border-[#25D366]/30 rounded-3xl p-8 md:p-10 text-center relative overflow-hidden" data-id="element-22" data-mp="zxy01v8raymm">
            {/* Background image */}
            <img src="https://cdn.magicpatterns.com/uploads/f4TXKfANotJzXqWz17dwgk/heylloyd-image-1782678048806.png" alt="" aria-hidden="true" className="absolute inset-0 w-full h-full object-cover" data-id="element-23" data-mp="2h3hn6kmywq49" />
            {/* Overlays for readability */}
            <div className="absolute inset-0 bg-dark/80" data-id="element-24" data-mp="2v4allgge45cn"></div>
            <div className="absolute inset-0 bg-gradient-to-br from-[#25D366]/25 to-dark/90" data-id="element-25" data-mp="2v1od9elodltd"></div>
            <div className="absolute top-0 right-0 w-32 h-32 bg-[#25D366]/10 rounded-full blur-3xl" data-id="element-26" data-mp="30095aqqrwz6q"></div>

            <div className="relative z-10" data-id="element-27" data-mp="39sf5uov3coxj">
              <div className="inline-flex items-center justify-center w-20 h-20 rounded-full bg-[#25D366] text-white mb-6 shadow-[0_0_30px_rgba(37,211,102,0.4)]" data-id="element-28" data-mp="39rdlfts6qq35">
                <MessageCircle className="w-10 h-10" data-id="element-29" data-mp="3istthuvj2g47" />
              </div>

              <h3 className="text-2xl font-bold text-white mb-2" data-id="element-30" data-mp="3ir0hs16255pc">
                CONTÁCTANOS POR WHATSAPP AHORA
              </h3>

              <p className="text-gray-300 mb-8" data-id="element-31" data-mp="1eps8p9k2o0mv">
                Escríbenos "WEBSITE" y te respondemos hoy
              </p>

              <div className="space-y-3 text-left max-w-sm mx-auto mb-10" data-id="element-32" data-mp="1shgk1amhyl2s">
                <div className="flex items-center gap-3" data-id="element-33" data-mp="1npez70b9jm15">
                  <Check className="w-5 h-5 text-[#25D366]" data-id="element-34" data-mp="1nnu5te0oq94v" />
                  <span className="text-white font-medium" data-id="element-35" data-mp="22djkmc1pabnm">
                    Respuesta rápida
                  </span>
                </div>
                <div className="flex items-center gap-3" data-id="element-36" data-mp="1xi47jmbiojs9">
                  <Check className="w-5 h-5 text-[#25D366]" data-id="element-37" data-mp="2be80zdekgo3o" />
                  <span className="text-white font-medium" data-id="element-38" data-mp="27e7bmxpxishu">
                    Sin presión ni compromiso
                  </span>
                </div>
                <div className="flex items-center gap-3" data-id="element-39" data-mp="h1rwoi5bzk1g">
                  <Check className="w-5 h-5 text-[#25D366]" data-id="element-40" data-mp="d0oh7wr73q0r" />
                  <span className="text-white font-medium" data-id="element-41" data-mp="d29azk5or4xk">
                    Te explicamos todo en minutos
                  </span>
                </div>
                <div className="flex items-center gap-3" data-id="element-42" data-mp="6w9tolxk9pzk">
                  <Check className="w-5 h-5 text-[#25D366]" data-id="element-43" data-mp="3pbssd8zcuin9" />
                  <span className="text-white font-medium" data-id="element-44" data-mp="3pbanjnymmw3q">
                    Empezamos cuando tú estés listo
                  </span>
                </div>
              </div>

              <a href="https://wa.me/447311754270?text=WEBSITE" target="_blank" rel="noopener noreferrer" className="block w-full py-4 px-8 bg-[#25D366] hover:bg-[#20bd5a] text-white font-bold rounded-full transition-all transform hover:scale-105 shadow-lg" data-id="element-45" data-mp="3fclgkq89qw29">
                ESCRIBIR POR WHATSAPP AHORA →
              </a>
            </div>
          </div>

          {/* Summary Card */}
          <div className="bg-dark rounded-3xl border border-white/10 p-8 md:p-10" data-id="element-46" data-mp="19k50hrz77gbb">
            <h3 className="text-xl font-bold text-white mb-8 text-center border-b border-white/10 pb-6" data-id="element-47" data-mp="35njd8hwerfkp">
              RESUMEN RÁPIDO DE LA OFERTA
            </h3>

            <div className="space-y-6" data-id="element-48" data-mp="30p9iu9iicj05">
              <div className="flex justify-between items-center pb-4 border-b border-white/5" data-id="element-49" data-mp="2vp3lqdtgy4ao">
                <span className="text-gray-400" data-id="element-50" data-mp="2rns34s90ijbz">
                  Website profesional completo
                </span>
                <span className="text-white font-bold text-right" data-id="element-51" data-mp="2mp70yna79pkw">
                  $250 pago único
                </span>
              </div>
              <div className="flex justify-between items-center pb-4 border-b border-white/5" data-id="element-52" data-mp="2hwnq3y2wd8js">
                <span className="text-gray-400" data-id="element-53" data-mp="2cz5fm398el9o">Para empezar solo</span>
                <span className="text-gold font-bold text-right" data-id="element-54" data-mp="280u6xvuoagt1">
                  $125 (50% adelantado)
                </span>
              </div>
              <div className="flex justify-between items-center pb-4 border-b border-white/5" data-id="element-55" data-mp="2400in1dbizzm">
                <span className="text-gray-400" data-id="element-56" data-mp="1z17cju0d2b9h">Listo en</span>
                <span className="text-white font-bold text-right" data-id="element-57" data-mp="egachb634tcw">
                  Menos de 72 horas
                </span>
              </div>
              <div className="flex justify-between items-center pb-4 border-b border-white/5" data-id="element-58" data-mp="jhzoat14tb21">
                <span className="text-gray-400" data-id="element-59" data-mp="nfxiybdo8pct">
                  Mensualidades obligatorias
                </span>
                <span className="text-white font-bold text-right" data-id="element-60" data-mp="3rw8ejug6lpr1">
                  $0 — No hay
                </span>
              </div>
              <div className="flex justify-between items-center pb-4 border-b border-white/5" data-id="element-61" data-mp="3vyd5umj5qaai">
                <span className="text-gray-400" data-id="element-62" data-mp="4qh22dhoika8">Mantenimiento opcional</span>
                <span className="text-white font-bold text-right" data-id="element-63" data-mp="9iijedtpf174">
                  $30/mes si lo deseas
                </span>
              </div>
              <div className="flex justify-between items-center pb-4 border-b border-white/5" data-id="element-64" data-mp="387pl30o57q6j">
                <span className="text-gray-400" data-id="element-65" data-mp="3d599gtek1jc7">Contrato largo</span>
                <span className="text-white font-bold text-right" data-id="element-66" data-mp="kbk4e66anhr0">
                  No existe
                </span>
              </div>
              <div className="flex justify-between items-center" data-id="element-67" data-mp="fbekjc69mzjh">
                <span className="text-gray-400" data-id="element-68" data-mp="t3m1buh5mfwj">Sorpresas de precio</span>
                <span className="text-white font-bold text-right" data-id="element-69" data-mp="p2sfd6n9vb6a">
                  No existen
                </span>
              </div>
            </div>
          </div>
        </div>
      </div>
    </section>;
}